import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {ChangeDetectorRef} from '@angular/core';
import {RuleService} from '../../../services/rule-service/rule.service';
import {FormDataService, SharedService} from '@ems/shared';
import {emtrConstant} from '../../../constants/emtrConstants';
import {SharedConstant} from '@ems/shared';
@Component({
    selector: 'tr-rules-step1-rule-type',
    templateUrl: './rules-step1.component.html',
    styleUrls: ['./rules-step1.component.scss']
})
export class RulesStep1Component implements OnInit {

    createRuleForm!: FormGroup;
    ruleNameExists = false;
    draftRuleName: string;
    public draftRuleId: any;
    sessionObj = this.formDataService.getLoginInfo();
    orgId = '';
    override = 'N';
    getConstant = emtrConstant;
    sharedConstant = SharedConstant;
    message: string;
    targetElem: any;
    cancelButton = false;
    continueToNavigate = false;
    disableRuleType = false;
    confirmMessage: any;
    showCharLimit: boolean;
    errorMsg = [];
    ruleNameExistsMsg = '';
    @ViewChild('focusName', { static: true }) inputEl: ElementRef;
    @ViewChild('confirmationMessage', { static: true }) confirmationMessage: any;
    is10b5Client = false;
    isEditMode = false;
    isDraftEdit = false;
    isGlobalCreateFlow = false;
    isCopyMode = false;
    isBlackoutEligible = false;
    planIDTxt = 'planId';
    showInvalidError = '';
    isFirstTimeValidation = true;
    step1FormData: any;
    isRuleNameModified = false;
    businessUnit: string;
    isRbsBU = false;
    oldFormObject: any;
    toEnableOpenBrokeragePlan: boolean = null;
    showOBPCheckbox = true;

  /* The 10b5-1 checkbox is shown for 10b5 clients while creating, and in Edit only when the rule
     itself is a 10b5 rule (a non-10b5 sub category such as Special Blackout must not reveal it). */
  get isTenB5CheckboxVisible(): boolean {
    return (this.is10b5Client && !this.isEditMode) ||
      (this.isEditMode && !!this.createRuleForm?.get('enable10b5Checkbox')?.value);
  }

  constructor(private router: Router, private fb: FormBuilder, public sharedService: SharedService,
              public ruleService: RuleService, public formDataService: FormDataService, private r: ActivatedRoute,
              public cd: ChangeDetectorRef, @Inject('commonConstants') public commonConstants, @Inject('entitlementConst') public entitlementConst) {
    this.ruleService.clearMessage();
    this.step1FormData = this.formDataService.getFormData();
    this.ruleService.duplicateRuleName.subscribe(value => {
      this.ruleNameExists = this.continueToNavigate = true;
      this.cancelButton = false;
    });
  }

    ngOnInit() {
        this.sharedService.clientInformation.subscribe(clientInfo => {
          this.businessUnit = clientInfo && clientInfo.businessUnit;
        });
        this.is10b5Client = this.sharedService.get10b5ClientDetails();
        /* Read businessUnit directly from the BehaviorSubject's current value so eligibility does not
           implicitly rely on the synchronous emission ordering of the subscription above. */
        this.isBlackoutEligible = this.sharedService.clientInformation.getValue()?.businessUnit === this.sharedConstant.spsBUText &&
          this.sharedService.applicationInfo?.data?.blackoutRestrictionEnabled === true;
        let enable10b5Checkbox;
        if (this.step1FormData.mode === 'EDIT') {
          this.isEditMode = true;
        } else {
          this.isEditMode = false;
        }
        this.isCopyMode = this.step1FormData.mode === 'Copy';
        /* On Copy of a Special Blackout rule while the feature switch (blackoutRestrictionEnabled) is off,
           remove the Special Blackout sub category entirely so it is neither pre-selected in step 1 nor
           carried over to step 2 / the backend. */
        if (this.isCopyMode && !this.isBlackoutEligible &&
            this.step1FormData.ruleSubCategory === this.sharedConstant.specialBlackout.subType) {
            this.step1FormData.ruleSubCategory = '';
        }
        const enableSpecialBlackoutCheckbox = this.step1FormData.ruleSubCategory === this.sharedConstant.specialBlackout.subType;

        if (this.step1FormData.planId) {
          enable10b5Checkbox = true;
        } else {
          enable10b5Checkbox = false;
        }
        /* Disabling the restriction Category if rule is saved as "DRAFT" */
        if (this.step1FormData.mode !== 'EDIT' && (this.is10b5Client || this.isBlackoutEligible) && this.step1FormData.isSavedAsDraft) {
          this.isDraftEdit = true;
        } else {
          this.isDraftEdit = false;
        }
        if (this.step1FormData.mode !== 'EDIT' && (this.step1FormData.isSavedAsDraft || this.step1FormData.mode === 'Copy')) {
          this.isGlobalCreateFlow = true;
        } else {
          this.isGlobalCreateFlow = false;
        }


        this.disableRuleType = !!this.step1FormData.mode || (this.step1FormData.isSavedAsDraft && this.step1FormData.globalRule);
        this.draftRuleName = this.step1FormData.name;
        this.draftRuleId = this.step1FormData.id;
        this.createRuleForm = this.fb.group({
            ruleName: [this.step1FormData.name, {validators: [Validators.required]}],
            rulesCategory: [{value: (this.step1FormData.override === 'Y') ? 'Override' : this.step1FormData.isSuperRestriction === 'Y' ? 'SUPER_RESTRICT' : this.step1FormData.rulesCategory, disabled: this.disableRuleType}, Validators.required],
            ruleType: [{value: this.step1FormData.ruleType, disabled: (this.disableRuleType || this.step1FormData.isSuperRestriction === 'Y')},  Validators.required],
            justification: [this.step1FormData.justification, Validators.required],
            otherInput: [this.step1FormData.otherInput],
            enable10b5Checkbox: [enable10b5Checkbox],
            enableSpecialBlackoutCheckbox: [enableSpecialBlackoutCheckbox],
            planId: [this.step1FormData.planId],
            globalRule: [this.step1FormData.globalRule],
            openBrokeragePlan: [this.step1FormData.ruleSubCategory === this.sharedConstant.openBrokerage.subType ? true : false, {disabled: this.isEditMode}]
        });
        if (this.isEditMode || this.isDraftEdit) {
          this.createRuleForm.get('planId').disable();
          this.createRuleForm.get('enable10b5Checkbox').disable();
          this.createRuleForm.get('enableSpecialBlackoutCheckbox').disable();
        } else {
          this.createRuleForm.get('planId').enable();
          this.createRuleForm.get('enable10b5Checkbox').enable();
          this.createRuleForm.get('enableSpecialBlackoutCheckbox').enable();
          /* On Copy and Create, keep 10b5-1 and Special Blackout mutually exclusive by disabling the counterpart of the selected checkbox (no-op when neither is pre-selected) */
          this.applyMutualExclusivity('enableSpecialBlackoutCheckbox', 'enable10b5Checkbox');
          this.applyMutualExclusivity('enable10b5Checkbox', 'enableSpecialBlackoutCheckbox');
        }
        if (this.step1FormData.toEnableOpenBrokeragePlan) {
          this.toEnableOpenBrokeragePlan = true;
          this.createRuleForm.get('openBrokeragePlan').disable();
        }
        // Disable globalRule checkbox when in edit mode or global create flow
        if (this.isEditMode || this.isGlobalCreateFlow) {
          this.createRuleForm.get('globalRule').disable();
          this.createRuleForm.get('openBrokeragePlan').disable();
        } else {
          this.createRuleForm.get('globalRule').enable();
        }

        this.oldFormObject = this.createRuleForm.getRawValue();
        // Set showOBPCheckbox to false if globalRule is not checked
        const isGlobalRuleSelected = Boolean(this.createRuleForm.get('globalRule')?.value);
        const isOpenBrokerageSubType =
          this.step1FormData.ruleSubCategory === this.sharedConstant.openBrokerage.subType;

        if (!isGlobalRuleSelected) {
          this.showOBPCheckbox = true;
        } else {
          const shouldShowInEditMode = this.isEditMode && !isOpenBrokerageSubType;
          const shouldForceShow = this.toEnableOpenBrokeragePlan === true;

          this.showOBPCheckbox = shouldForceShow || shouldShowInEditMode;
        }
        this.onChanges();
        this.ruleNameExists = false;
        this.confirmMessage = this.confirmationMessage.confirmMessage;
        if ( this.businessUnit === this.sharedConstant.rbsBUText || this.businessUnit === '' ) {
          this.createRuleForm.get('ruleName').reset();
          this.createRuleForm.get('ruleName').clearValidators();
          this.isRbsBU = true;
        } else  {
          this.createRuleForm.get('ruleName').setValidators([Validators.required]);
          this.isRbsBU = false;
        }
        this.createRuleForm.get('ruleName').updateValueAndValidity();
    }

    canDeactivate(event, observer) {
        this.confirmMessage.message = this.confirmMessage.message ? this.confirmMessage.message : this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
        if (this.cancelButton === false && (this.createRuleForm.dirty || this.createRuleForm.get('ruleName').value)) {
          return this.confirmationMessage.showConfirmMsg(this.confirmMessage, observer);
        }
        return true;
    }

    onChanges(): void {
        if (this.createRuleForm.get('rulesCategory').value !== 'Override') {
            this.createRuleForm.get('justification').disable();
        }
        if (this.createRuleForm.get('justification').value !== 'Other') {
            this.createRuleForm.get('otherInput').disable();
        }
      this.createRuleForm.get('globalRule').valueChanges.subscribe((globalValue) => {
        this.setFormValueForSecuritySection();
        if (globalValue && !this.isEditMode && this.sharedService.checkEntitlements(this.entitlementConst.navUUID.ngOMS.manageGlobalRuleObp.uuid, '', '') &&
          this.createRuleForm.get('rulesCategory')?.value === 'RESTRICT_LST_ENG'  && this.createRuleForm.get('ruleType')?.value === 'SECTYP' ) {
          const formObj = { OBPCheck: true };
          this.checkWhetherRuleNameExists(formObj);
        }
      });
        this.createRuleForm.get('rulesCategory').valueChanges.subscribe((rulesCategoryValue) => {
          /* Clearing planId if Rule Type is changed */
          if (this.is10b5Client) {
            this.createRuleForm.patchValue({
              enable10b5Checkbox: '',
              planId: ''
            });
          }
          /* Clearing Special Blackout selection if Rule Category is changed */
          if (this.isBlackoutEligible) {
            this.createRuleForm.patchValue({
              enableSpecialBlackoutCheckbox: false
            });
          }
          /* ReSetting the rule subType if fundFamily is already Selected and switches between 'Override' and 'WatchList' */
          if (rulesCategoryValue === 'WATCH_LST_ENG' || rulesCategoryValue === 'Override') {
            this.createRuleForm.get('ruleType').reset();
            this.createRuleForm.get('globalRule').reset();
            this.createRuleForm.get('openBrokeragePlan').reset();
          }
          const rulesCategoryControl = this.createRuleForm.get('rulesCategory');
          const ruleTypeControl = this.createRuleForm.get('ruleType');

          if (rulesCategoryControl?.value === 'SUPER_RESTRICT') {
            ruleTypeControl?.setValue('SECTYP');
            ruleTypeControl?.disable();
          } else if (!this.isEditMode) {
            ruleTypeControl?.enable();
          }
          this.setFormValueForSecuritySection();
        });

        this.createRuleForm.get('ruleType').valueChanges.subscribe((rulesType) => {
          /* Resetting the global rule checkbox if 'Security Type' is not selected */
            this.createRuleForm.get('globalRule').reset();
            this.createRuleForm.get('openBrokeragePlan').reset();
          this.setFormValueForSecuritySection();
        });

        this.createRuleForm.get('ruleName').valueChanges.subscribe((ruleNameValue) => {
          this.ruleNameExists = this.continueToNavigate = false;

          /*To clear the rulename exists warning msg*/
          this.ruleService.toastMsg.emit('');
          this.ruleService.toastType.emit('');
          this.sharedService.closeToast = false;

          const regExp = new RegExp('^[a-zA-Z0-9+_()\[\\],.\\- ]*$');
          if (ruleNameValue && !regExp.test(ruleNameValue)) {
            if (this.errorMsg.indexOf(this.getConstant.rulesConstant.ruleNameMsg.invalidCharacter) === -1) {
              this.errorMsg.push(this.getConstant.rulesConstant.ruleNameMsg.invalidCharacter);
            }
            this.ruleService.showSchError.emit(true);
          } else {
            if (this.errorMsg.indexOf(this.getConstant.rulesConstant.ruleNameMsg.invalidCharacter) !== -1) {
              this.isFirstTimeValidation = true;
              this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.rulesConstant.ruleNameMsg.invalidCharacter), 1);
            }
          }
          /*Hide the error block when errorMsg is empty*/
          if (this.errorMsg.length === 0) {
            this.ruleService.showSchError.emit(false);
          }
          this.ruleService.schErrorMsg.emit(this.errorMsg);

          if (!this.isFirstTimeValidation) {
            this.isRuleNameModified = true;
          }
        });
        this.createRuleForm.get('planId').valueChanges.subscribe((value) => {
          if (value && this.createRuleForm.get('planId').invalid && this.errorMsg.indexOf(this.getConstant.rule10b5Msg.invalidCharacterEnteredNumericValue) === -1) {
            this.errorMsg.push(this.getConstant.rule10b5Msg.invalidCharacterEnteredNumericValue);
          } else {
            if ((value === '' && this.showInvalidError !== 'emp-grp') || (this.errorMsg.indexOf(this.getConstant.rule10b5Msg.invalidCharacterEnteredNumericValue) !== -1 &&
              !this.createRuleForm.get('planId').invalid)) {
              if (this.errorMsg.indexOf(this.getConstant.rule10b5Msg.invalidCharacterEnteredNumericValue) > -1) {
                this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.rule10b5Msg.invalidCharacterEnteredNumericValue), 1);
              }
              if (this.showInvalidError === 'planId' || this.showInvalidError === 'both') {
                const planIdTxt = 'planId';
                this.createRuleForm.controls[planIdTxt].setErrors({incorrect: false});
              }
            }
          }

          /* Removing groupName existed error if new value is entered */
          if (this.showInvalidError === 'planId' && this.errorMsg.length > 0 && this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicatePlanId) !== -1
            && this.is10b5Client && !this.createRuleForm.get('planId').invalid) {
            this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicatePlanId), 1);
            this.showInvalidError = '';
          }

          /* Removing both(groupName & planId) existed error if new value is entered  in both fields*/
          if (this.showInvalidError === 'both' && this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicateRuleNameAndPlanId) !== -1 &&
            this.is10b5Client && !this.createRuleForm.get('planId').invalid) {
            this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicateRuleNameAndPlanId), 1);
            this.showInvalidError = '';
          }

          this.ruleService.schErrorMsg.emit(this.errorMsg);
          if (this.errorMsg.length === 0) {
            this.ruleService.showSchError.emit(false);
          } else {
            this.ruleService.showSchError.emit(true);
          }
        });
        this.enableInput('rulesCategory', 'Override', 'justification');
        this.enableInput('justification', 'Other', 'otherInput');
    }

    enableInput(param1, param2, param3) {
        this.createRuleForm.get(param1).valueChanges.subscribe((value) => {
            if (value === param2) {
                this.createRuleForm.get(param3).enable();
            } else {
                this.createRuleForm.get(param3).reset();
                this.createRuleForm.get(param3).disable();
            }
        });
    }

  goToNextStep() {
    this.cancelButton = true;
    const formObj = this.buildStep1FormObject();
    const sortedOld = this.sortObjectKeys(this.oldFormObject);
    const sortedNew = this.sortObjectKeys(formObj);
    if (JSON.stringify(sortedOld) !== JSON.stringify(sortedNew)) {
      this.ruleService.checkIfChangesMadeInStep1 = true;
    } else {
      this.ruleService.checkIfChangesMadeInStep1 = false;
    }
    if (this.createRuleForm.get('rulesCategory')?.value === 'SUPER_RESTRICT') {
      formObj['rulesCategory'] = this.createRuleForm.get('rulesCategory')?.value === 'SUPER_RESTRICT' ? 'RESTRICT_LST_ENG' : this.createRuleForm.get('rulesCategory')?.value;
    }
    if (this.isRbsBU || (this.draftRuleName === formObj.ruleName && this.draftRuleId) || (this.continueToNavigate && !this.is10b5Client)) {
      this.ruleNameExists = false;
      if (this.isRbsBU && this.step1FormData.mode === '') {
        /* Continue button click GUTtracking value for adobe analytics - Only to be called in Create flow */
        this.sharedService.gutTracking('adobe-lc_rule_step1continue');
      }
      this.navigateTo(formObj);
    } else {
      this.checkWhetherRuleNameExists(formObj);
    }
  }

  buildStep1FormObject(): Record<string, any> {
    const ruleName = this.createRuleForm.get('ruleName')?.value;
    const rulesCategory = this.createRuleForm.get('rulesCategory')?.value;
    const openBrokeragePlan = this.createRuleForm.get('openBrokeragePlan')?.value;

    const formObj: Record<string, any> = {
      ruleName: ruleName ? ruleName.trim() : this.step1FormData.name ? this.step1FormData.name : '',
      rulesCategory,
      ruleType: this.createRuleForm.get('ruleType')?.value,
      justification: this.createRuleForm.get('justification')?.value,
      otherInput: this.createRuleForm.get('otherInput')?.value,
      enable10b5Checkbox: this.createRuleForm.get('enable10b5Checkbox')?.value,
      enableSpecialBlackoutCheckbox: this.createRuleForm.get('enableSpecialBlackoutCheckbox')?.value,
      planId: this.createRuleForm.get('planId')?.value,
      globalRule: this.createRuleForm.get('globalRule')?.value,
    };

    if (openBrokeragePlan) {
      formObj.ruleSubCategory = this.sharedConstant.openBrokerage.subType;
      this.oldFormObject.ruleSubCategory = this.sharedConstant.openBrokerage.subType;
    } else {
      delete formObj.openBrokeragePlan;
      delete formObj.ruleSubCategory;
    }

    if (!openBrokeragePlan) {
      delete this.oldFormObject.openBrokeragePlan;
    }

    if (rulesCategory === 'SUPER_RESTRICT') {
      formObj.isSuperRestriction = 'Y';
      this.oldFormObject.isSuperRestriction = 'Y';
    }

    return formObj;
  }

  checkWhetherRuleNameExists(ruleObj) {
    this.orgId = this.ruleService.orgId;
    const reqPayload = this.createRequestPayload(ruleObj);

    this.ruleService.checkRuleNameExists(reqPayload).subscribe(res => {
      if (ruleObj?.OBPCheck) {
        if (!this.isEditMode && res && res.data) {
          this.showOBPCheckbox = true; 
          this.toEnableOpenBrokeragePlan = res.data.ruleSubCategory === this.sharedConstant.openBrokerage.subType;
        } else {
          this.showOBPCheckbox = this.isEditMode && this.step1FormData.ruleSubCategory === this.sharedConstant.openBrokerage.subType ? false : res?.data ? true : false;;
          this.toEnableOpenBrokeragePlan = false;
        }
        this.createRuleForm.get('openBrokeragePlan')[this.toEnableOpenBrokeragePlan ? 'disable' : 'enable']();
      } else {
        this.handleResponse(res, ruleObj);
      }
    }, (error)=>{
      this.toEnableOpenBrokeragePlan = false;
      this.createRuleForm.get('openBrokeragePlan')[this.toEnableOpenBrokeragePlan ? 'enable' : 'disable']();
    });
  }

  createRequestPayload(ruleObj) {
    return !ruleObj?.OBPCheck ? {
      ruleName: ruleObj.ruleName.trim(),
      orgId: this.orgId,
      planId: (this.is10b5Client && this.createRuleForm.get('planId').value && !this.isEditMode) ? this.createRuleForm.get('planId').value : ''
    } : ruleObj;
  }

  handleResponse(res, ruleObj) {
    this.sharedService.decodeUrl = true;
    this.continueToNavigate = !(res.data);
    const resposeValidation = this.sharedService.setResponseMessage(res, this.is10b5Client, this.createRuleForm.get('ruleName').value.trim(), this.createRequestPayload(ruleObj).planId, this.getConstant, 'Rules');
    const validatedField = this.ruleService.validateNameAndPlanId(resposeValidation.data.message, this.createRuleForm);
    this.showInvalidError = validatedField;

    if (validatedField !== 'ruleName') {
      this.cancelButton = false;
    }

    this.removeDuplicateRuleNameError(resposeValidation);
    this.showValidationErrors(resposeValidation);
    this.ruleService.schErrorMsg.emit(this.errorMsg);
    this.checkForNavigation(resposeValidation, ruleObj);
  }

  removeDuplicateRuleNameError(resposeValidation) {
    if (resposeValidation.data.message !== this.getConstant.rule10b5Msg.duplicateRuleName &&
      this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicateRuleNameAndPlanId) !== -1 && this.is10b5Client) {
      this.errorMsg.splice(this.errorMsg.indexOf(this.getConstant.rule10b5Msg.duplicateRuleNameAndPlanId), 1);
    }
  }

  checkForNavigation(resposeValidation, ruleObj) {
    if ((!this.isFirstTimeValidation && resposeValidation.data.message === this.getConstant.rule10b5Msg.duplicateRuleName) ||
      resposeValidation.data.message === this.getConstant.rule10b5Msg.ruleNameNotExists) {
      this.cancelButton = true;
      this.createRuleForm.controls['planId'].setValidators(null);
      this.createRuleForm.controls['planId'].updateValueAndValidity();
      if (this.step1FormData.mode === '') {
        this.sharedService.gutTracking('adobe-lc_rule_step1continue');
      }
      this.navigateTo(ruleObj);
    }
    this.isFirstTimeValidation = false;
/* res.data.message is  'Rule must be created with a unique plan id'  setting the 'isFirstTimeValidation' as true for Navigation to Step 2*/
    if (resposeValidation.data.message === this.getConstant.rule10b5Msg.duplicateRuleNameAndPlanId || this.isRuleNameModified) {
      this.isFirstTimeValidation = true;
    }
  }

  showValidationErrors(res) {
    if (this.errorMsg.indexOf(res.data.message) === -1 && (res.data.message !== this.getConstant.rule10b5Msg.duplicateRuleName &&
      res.data.message !== this.getConstant.rule10b5Msg.ruleNameNotExists)) {
      /*To clear the rulename exists warning msg*/
      this.ruleService.toastMsg.emit('');
      this.ruleService.toastType.emit('');
      this.sharedService.closeToast = false;
      this.ruleNameExists = false;
      this.errorMsg.push(res.data.message);
      this.ruleService.showSchError.emit(true);
    } else if (this.errorMsg.indexOf(res.data.message) !== -1) {
      this.errorMsg.splice(this.errorMsg.indexOf(res.data.message), 1);
      this.ruleService.showSchError.emit(false);
    }
  }

    buildStep1RuleObject(steps) {
      const ruleObj = {
        ruleName: steps.ruleName.trim(),
        rulesCategory: (steps.rulesCategory === 'Override') ? 'RESTRICT_LST_ENG' : steps.rulesCategory,
        ruleType: steps.ruleType,
        override: (steps.rulesCategory === 'Override') ? 'Y' : 'N',
        orgId: this.ruleService.orgId,
        justification: steps.justification,
        otherInput: steps.otherInput,
        planId: steps.planId,
        globalRule: steps.globalRule
      };

      if (steps.enable10b5Checkbox || this.formDataService.getFormData().mode === '') {
        ruleObj['ruleSubCategory'] = steps.enable10b5Checkbox ? '10b5-1' : this.subCategoryDefaultValue();
      } else if (steps.ruleSubCategory) {
        ruleObj['ruleSubCategory'] = steps.ruleSubCategory;
      }

      /* Special Blackout takes precedence and overrides the sub category (no plan id). */
      if (steps.enableSpecialBlackoutCheckbox) {
        ruleObj['ruleSubCategory'] = this.sharedConstant.specialBlackout.subType;
      }

      if (this.toEnableOpenBrokeragePlan) {
        ruleObj['toEnableOpenBrokeragePlan'] = this.toEnableOpenBrokeragePlan;
      }

      if (steps.isSuperRestriction) {
        ruleObj['isSuperRestriction'] = steps.isSuperRestriction;
      }

      return ruleObj;
    }

    navigateTo(steps) {
        const ruleObj = this.buildStep1RuleObject(steps);
        this.formDataService.setStep1(ruleObj, true);

        /*To clear the rulename exists warning msg*/
        this.ruleService.toastMsg.emit('');
        this.ruleService.toastType.emit('');
        this.sharedService.closeToast = false;
       

        this.router.navigate(['../step2'], {relativeTo: this.r});
    }

    cancelCreateRule() {
        this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.cancelBtnClickMsg;
        this.router.navigate(['/ems/emtr/rules/rules-list']);
    }

    onClose() {
        this.cd.detectChanges();
        this.inputEl.nativeElement.focus();
        this.ruleNameExists = false;
    }

    /* Enforce mutual exclusivity between two checkboxes: when the changed control is checked,
       uncheck its counterpart; in Copy and Create modes also disable the counterpart to lock the
       selection (and re-enable it when the changed control is unchecked). */
    applyMutualExclusivity(changedControl: string, counterpartControl: string) {
      const counterpart = this.createRuleForm.get(counterpartControl);
      /* Copy and Create flows keep both checkboxes interactive, so toggle the counterpart's
         enabled state; Edit/Draft flows disable the controls entirely and are left untouched. */
      const toggle10b51Blackout = !this.isEditMode && !this.isDraftEdit;
      if (this.createRuleForm.get(changedControl).value) {
        counterpart.setValue(false);
        if (toggle10b51Blackout) {
          counterpart.disable();
        }
      } else if (toggle10b51Blackout) {
        counterpart.enable();
      }
    }

    /* If '10b5' checkbox is checked/unchecked adding planId Validators */
    selected10b5() {
      /* 10b5-1 and Special Blackout are mutually exclusive */
      this.applyMutualExclusivity('enable10b5Checkbox', 'enableSpecialBlackoutCheckbox');
      this.sharedService.set10b5Validators(this.createRuleForm, this.planIDTxt);
    }

    /* If 'Special Blackout' checkbox is checked/unchecked, enforce mutual exclusivity with 10b5-1 */
    selectedSpecialBlackout() {
      this.applyMutualExclusivity('enableSpecialBlackoutCheckbox', 'enable10b5Checkbox');
      if (this.createRuleForm.get('enableSpecialBlackoutCheckbox').value) {
        /* Clear planId and its validators as 10b5-1 is now unchecked */
        this.sharedService.set10b5Validators(this.createRuleForm, this.planIDTxt);
      }
    }

  setFormValueForSecuritySection() {
    if (this.ruleService.previousStep && this.businessUnit !== this.sharedConstant.spsBUText) {
    const objVal = {
      chooseSecurityType: '',
      secCatgs1: [],
      secCatgs2: [],
      secCatgs3: [],
      assetGroups: [],
      presetRuleKey: '',
      presetRuleId: '',
      instrumentGroups: [],
      indSecs: [],
      appliesTo: []
    };
    this.formDataService.setSecurityValue(objVal);
    }
  }

  removeLeadingZeroes() {
    const value = this.createRuleForm.getRawValue().planId ? this.createRuleForm.getRawValue().planId.toString().replace(/^0+/, '') : '';
    this.createRuleForm.get('planId').setValue(value);
    if (value === '0') {
      this.createRuleForm.get('planId').reset();
      this.selected10b5();
    }
  }
  subCategoryDefaultValue() {
    const isEditMode = this.formDataService.getFormData().mode !== '';
    if (!isEditMode && !this.createRuleForm.get('openBrokeragePlan').value) {
      this.formDataService.formData.presetRuleKey = '';
    }
    return (isEditMode && this.step1FormData.ruleSubCategory === this.sharedConstant.openBrokerage.subType) ||
           this.createRuleForm.get('openBrokeragePlan').value
      ? this.sharedConstant.openBrokerage.subType
      : '';
  }
  sortObjectKeys(formData: any): any {
    if (formData === null || typeof formData !== 'object') {
      return formData;
    }
    if (Array.isArray(formData)) {
      return formData.map(item => this.sortObjectKeys(item));
    }
    return Object.keys(formData).sort().reduce((result, key) => {
      result[key] = this.sortObjectKeys(formData[key]);
      return result;
    }, {});
  }
  globalCheckboxValidation() {
    const rulesCategory = this.createRuleForm.get('rulesCategory')?.value;
    const ruleType = this.createRuleForm.get('ruleType')?.value;

    const isAllowedCategory = rulesCategory === 'RESTRICT_LST_ENG' || rulesCategory === 'Override' || rulesCategory === 'SUPER_RESTRICT';
    const isAllowedRuleType = ruleType === 'SECTYP' || ruleType === 'INDSEC';

    return isAllowedCategory &&
      isAllowedRuleType &&
      this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid, '', '');
  }
}
